import mixpanel from "mixpanel-browser";

const useBundleBuilderMixpanelHook = () => {
    function trackBbStep({ cta = "", stepId = 0, ctaType = "" }) {
        const temp = {
            "Step ID": stepId || "-",
            Cta: cta,
            "Cta Type": ctaType,
        };
        console._log("track BB - Step Event", temp);

        mixpanel.track("BB - Step Event", temp);
    }

    function trackBbUpsellButton({ cta = "", formId = "", ctaType = "" }) {
        const temp = {
            "Form ID": formId,
            Cta: cta,
            "Cta Type": ctaType,
        };
        console._log("track BB - Upsell Button", temp);

        mixpanel.track("BB - Upsell Button", temp);
    }

    return { trackBbStep, trackBbUpsellButton };
};

export default useBundleBuilderMixpanelHook;
